import Description from "@components/CustomTypography/Description/Description"
import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Title from "@components/CustomTypography/Title/Title"
import ButtonSwitcher from "@components/Switchers/ButtonSwitcher/ButtonSwitcher"
import CustomeSelect from "@components/Theme/Select/CustomSelect/CustomSelect"
import {direction} from "@customTypes/customTypes"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React, {useState} from "react"
import {EffectFade, Keyboard, Scrollbar} from "swiper"
import {Swiper, SwiperSlide} from "swiper/react"

// Import Swiper styles
import "swiper/css"
import "swiper/css/scrollbar"
import "swiper/css/effect-fade"

import styles from "./ButtonSlider.module.scss"

type Props = {
	data: AdvancedSideAssetMainContent[]
	centered?: boolean
	flexD: direction
	style?: "default" | "fullWidth"
}

const ButtonSlider = (props: Props) => {
	const [swiperRef, setSwiperRef] = useState(null)
	const [activeSlideIndex, setActiveSlideIndex] = useState(1)

	const stylesType = {
		default: styles.default,
		fullWidth: styles.fullWidth,
	}

	const slideTo = (index: number | {[key: string]: string[]}) => {
		if (typeof index === "number") {
			setActiveSlideIndex(index)
			// @ts-expect-error
			swiperRef.slideTo(Number(index) - 1, 300)
		} else {
			if (index.useCases !== null && swiperRef !== null) {
				setActiveSlideIndex(Number(index.useCases))
				// @ts-expect-error
				swiperRef.slideTo(Number(index.useCases) - 1, 300)
			}
		}
	}
	const handleSlideChange = (swiper: any) => {
		setActiveSlideIndex(swiper.realIndex)
	}

	const selectValues = props.data.map(
		(element: AdvancedSideAssetMainContent, index: number) => {
			return {
				slug: String(index + 1),
				id: index + 1,
				title: element.title ? element.title : "",
			}
		},
	)

	return (
		<>
			<p
				className={`${styles.buttons} ${
					stylesType[props.style ? props.style : "default"]
				}`}
				style={{textAlign: props.centered ? "center" : "left"}}
			>
				{props.data?.map(
					(element: AdvancedSideAssetMainContent, index: number) => {
						return (
							<button
								key={index}
								className={`${styles.button} ${
									activeSlideIndex === index + 1
										? styles.active
										: ""
								} ${
									stylesType[
										props.style ? props.style : "default"
									]
								}`}
								style={{
									flex: `0 0 calc(100% / ${props.data.length})`,
								}}
								onClick={() => slideTo(index + 1)}
							>
								<Description
									className={styles.buttonText}
									content={element.title}
									size={"M"}
								/>
							</button>
						)
					},
				)}
			</p>
			<CustomeSelect
				activeValue={[selectValues[activeSlideIndex - 1].slug]}
				className={styles.select}
				enableAll={false}
				name={"useCases"}
				options={selectValues}
				onChange={slideTo}
			/>

			<div style={{position: "relative"}}>
				<Swiper
					className={`"mySwiper " ${styles.sliderContainer}`}
					effect={"fade"}
					fadeEffect={{crossFade: true}}
					keyboard={{
						enabled: true,
					}}
					modules={[EffectFade, Scrollbar, Keyboard]}
					pagination={{
						clickable: true,
					}}
					slidesPerGroupSkip={1}
					slidesPerView={1}
					speed={300}
					scrollbar
					onSlideChange={handleSlideChange}
					// @ts-expect-error
					onSwiper={setSwiperRef}
				>
					{props.data?.map(
						(
							element: AdvancedSideAssetMainContent,
							index: number,
						) => {
							return (
								<SwiperSlide
									key={index}
									className={styles.swiperSlide}
									virtualIndex={index + 1}
								>
									<div
										className={`${styles.box} ${
											styles[props.flexD]
										}`}
									>
										<div
											className={styles.contentContainer}
										>
											<Title
												className={styles.title}
												content={element.title}
												size={"M"}
											/>
											<Description
												className={styles.text}
												content={element.content}
												size={"M"}
											/>
											<div>
												<ButtonSwitcher
													buttonsList={element}
												/>
											</div>
										</div>
										{element.preview && (
											<NewResponsiveImage
												{...element.preview}
												containerClassName={
													styles.imageContainer
												}
												imageClassName={styles.image}
											/>
										)}
									</div>
								</SwiperSlide>
							)
						},
					)}
				</Swiper>
			</div>
		</>
	)
}

export default ButtonSlider
